// extracted by mini-css-extract-plugin
export default {"policyText":"softOptInPhoneNumberPolicyText__policyText--V_sMs","policyLink":"softOptInPhoneNumberPolicyText__policyLink--SCta6"};